import { render, staticRenderFns } from "./ExamInfoDialog.vue?vue&type=template&id=56f20d90&scoped=true"
import script from "./ExamInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamInfoDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ExamInfoDialog.vue?vue&type=style&index=0&id=56f20d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f20d90",
  null
  
)

export default component.exports